import { render, staticRenderFns } from "./SettingsAdvanced.vue?vue&type=template&id=450f5d65&"
import script from "./SettingsAdvanced.vue?vue&type=script&lang=js&"
export * from "./SettingsAdvanced.vue?vue&type=script&lang=js&"
import style0 from "./SettingsAdvanced.vue?vue&type=style&index=0&id=450f5d65&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports